import Auth from '@aws-amplify/auth'
import store from './store/index.js'
import awsconfig from './aws-exports.js'

Auth.configure(awsconfig)


export default {
  user: null,
  handleSignIn: async function (username, password) {
    try {
      const user = await Auth.signIn(username, password);
      if(user.challengeName === 'NEW_PASSWORD_REQUIRED'){
        console.log('challenge new password')
        store.commit('setUser', user)
        return 'change-pass'
      }
      else {
        await this.checkUser(store)
        await store.dispatch('updateProfile')
        if(store.state.token){
          return 'ok'
        }
      }
    
    } catch (err) {
      console.log('signin error (auth-handler)', err)
      if(err.code === 'PasswordResetRequiredException'){
        return 'reset-pass'
      }
      else if(err.code === 'UserNotConfirmedException'){
        return 'confirm-email'
      }
      return 'fail'
    }
    return 'no-message'
  },
  handleCompletePassword: async function (password) {
    
    await Auth.completeNewPassword(store.state.user, password)
    await store.dispatch('checkUser')
    
  },
  handleSignOut: async function() {
    try {
      await Auth.signOut()
      await this.checkUser(store)
      return true
    }
    catch(err) {
      console.log(err)
    }
    return false
  },
  async forgotPassword(username) {
    await Auth.forgotPassword(username)
  },
  async confirmSignup(email, code) {
    Auth.confirmSignUp(email, code)
  },
  async checkUser(context){
    try {
      
      let user = await Auth.currentAuthenticatedUser()
      if(user) {
        const currentSession = await Auth.currentSession()
        if(currentSession) {
          context.commit('setUserData', currentSession)
        }
        else {
          context.commit('setToken', null)
        }
        if(!context.state.profile) {
          await context.dispatch('updateProfile')
        }
      }
      
    }
    catch(err) {
      context.commit('setProfile', null)
      context.commit('setToken', null)
    }
  }
}